import { generateCodeData } from '../libs/apis/GenerateCodeApi';

export const GENERATE_CODE_REQUEST = 'GENERATE_CODE_REQUEST';
export const GENERATE_CODE_SUCCESS = 'GENERATE_CODE_SUCCESS';
export const GENERATE_CODE_FAILURE = 'GENERATE_CODE_FAILURE';

export const generateCode = params => dispatch => {
  dispatch({ type: GENERATE_CODE_REQUEST });
  return generateCodeData(params)
    .then(response =>
      dispatch({
        type: GENERATE_CODE_SUCCESS,
        payload: response.data
      })
    )
    .catch(error =>
      dispatch({
        type: GENERATE_CODE_FAILURE,
        payload: error.response,
        error: true
      })
    );
};
